export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js